<template>
  <BaseScreen v-bind="screen">
    <button
      slot="title"
      class="screen__logo"
      @click="onLogoClick"
    >
      <BaseIcon name="logo_light" />
    </button>
    <div class="screen__row screen__stretch screen__row_column">
      <div class="screen__col screen__col_stretch">
        <BaseMenu
          :items="menuItems"
        />
      </div>
      <div v-if="rate" class="screen__col">
        <Rate
          v-bind="rate"
          class="screen__rate"
          @rate="setScore"
        />
      </div>
    </div>
  </BaseScreen>
</template>

<script>
import { GLOBAL_EVENTS } from '@/App.vue';
import { SCORES } from '@/screens/Rate.vue';

import screenMixin from '@/mixins/screen';
import terminalMixin from '@/mixins/terminal';

import BaseIcon from '@/components/BaseIcon.vue';
import BaseMenu from '@/components/BaseMenu.vue';
import Rate from '@/components/Rate.vue';

const SECRET_ACTION_CLICK_COUNT = 5;

export default {
  name: 'HomeScreen',
  mixins: [screenMixin, terminalMixin],
  components: {
    BaseIcon,
    BaseMenu,
    Rate,
  },
  data() {
    return {
      isInteractionStarted: false,
      isTerminalReady: false,
      clickCount: 0,
    };
  },
  staticData: () => ({
    clickTimeout: null,
  }),
  computed: {
    screenCase() {
      if (!this.isInteractionStarted) {
        return 'STEP_START';
      }
      return 'STEP_HOME';
    },
    isBuyDisabled() {
      return !this.isTerminalReady;
    },
    isPatternBackground() {
      return true;
    },
    rate() {
      return {
        title: {
          text: this.$t('home.rate'),
          size: 'l',
        },
        scores: [
          {
            icon: {
              name: 'smile_bad',
              theme: 'primary',
              view: 'rect',
              size: 'l',
            },
            score: SCORES.BAD,
          },
          {
            icon: {
              name: 'smile_fine',
              theme: 'primary',
              view: 'rect',
              size: 'l',
            },
            score: SCORES.FINE,
          },
          {
            icon: {
              name: 'smile_great',
              theme: 'primary',
              view: 'rect',
              size: 'l',
            },
            score: SCORES.GREAT,
          },
        ],
      };
    },
    menuItems() {
      return [
        {
          label: {
            text: this.$t('home.faq'),
            size: 'l',
          },
          action: this.goToFaqScreen,
        },
        {
          label: {
            text: this.$t('home.events'),
            size: 'l',
          },
          action: this.showEvents,
        },
        this.isBuyDisabled ? {
          label: {
            text: this.$t('home.selfie'),
            size: 'l',
          },
          action: this.goToSelfieScreen,
        } : {
          label: {
            text: this.$t('home.tickets'),
            size: 'l',
          },
          action: this.goToTicketsScreen,
        },
        {
          label: {
            text: this.$t('home.entertainment'),
            size: 'l',
          },
          action: this.goToEntertainmentScreen,
        },
        {
          label: {
            text: this.$t('home.feedback'),
            size: 'l',
          },
          action: this.goToFeedbackScreen,
        },
      ].filter(Boolean);
    },
  },
  beforeRouteEnter(to, from, next) {
    const isStopped = to.params[GLOBAL_EVENTS.INTERACTION_STOPPED];
    const hasPrevName = Boolean(from?.name); // Во время первой загрузки from.name = null
    const isStarted = typeof isStopped === 'boolean' ? !isStopped : hasPrevName;
    return next((vm) => (vm.isInteractionStarted = isStarted)); // eslint-disable-line
  },
  created() {
    this.initActions([
      ['ACTION_GO_FAQ', this.goToFaqScreen],
      ['ACTION_GO_TICKETS', this.goToTicketsScreen],
      ['ACTION_GO_SELFIE', this.goToSelfieScreen],
      ['ACTION_GO_ENTERTAINMENT', this.goToEntertainmentScreen],
      ['ACTION_GO_FEEDBACK', this.goToFeedbackScreen],
      ['ACTION_SHOW_EVENTS', this.showEvents],
    ]);
    this.checkTerminalHealth();
  },
  beforeDestroy() {
    this.clearClickTimeout();
  },
  methods: {
    onInteractionStarted() {
      this.isInteractionStarted = true;
    },
    onInteractionStopped() {
      this.isInteractionStarted = false;
    },
    goToFaqScreen() {
      this.$router.push(this.$router.options.paths.faq);
    },
    goToTicketsScreen() {
      if (this.isBuyDisabled) return;
      this.$router.push(this.$router.options.paths.tickets);
    },
    goToSelfieScreen() {
      this.$router.push(this.$router.options.paths.selfie);
    },
    goToEntertainmentScreen() {
      this.$router.push(this.$router.options.paths.entertainment);
    },
    goToFeedbackScreen() {
      this.$router.push(this.$router.options.paths.feedback);
    },
    showEvents() {
      this.$robot.dialogService.sayReplicByName('STEP_EVENTS', true);
    },
    onTerminalCheckComplete() {
      // Этот колбек будет вызван из миксина, после проверки терминала
      this.isTerminalReady = true;
    },
    onTerminalPaperOut() {
      // Этот колбек будет вызван из миксина, если кончилась бумага
      this.isTerminalReady = false;
    },
    onLogoClick() {
      this.clickCount += 1;
      if (this.clickCount >= SECRET_ACTION_CLICK_COUNT) {
        this.$router.push(this.$router.options.paths.admin);
      }
      if (!this.clickTimeout) {
        this.clickTimeout = window.setTimeout(() => {
          this.clearClickCount();
          this.clearClickTimeout();
        }, 2000);
      }
    },
    clearClickCount() {
      this.clickCount = 0;
    },
    clearClickTimeout() {
      window.clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
    },
    setScore(score) {
      this.$router.push({
        path: this.$router.options.paths.rate,
        query: { score },
      });
    },
  },
};
</script>
